// App routes. Template: ROUTE_<name>
export const ROUTE_MAIN = "/";
export const ROUTE_LOGIN = "/login";
export const ROUTE_ADMIN = "/admin";
export const ROUTE_PATHMATICS_LEVEL1 = "/pathmatics/level1";
export const ROUTE_PATHMATICS_LEVEL2 = "/pathmatics/level2";
export const ROUTE_PATHMATICS_LEVEL3 = "/pathmatics/level3";
export const ROUTE_BIS_LEVEL1 = "/bis/level1";
export const ROUTE_BIS_LEVEL2 = "/bis/level2";
export const ROUTE_BIS_LEVEL3 = "/bis/level3";
export const ROUTE_BIS_MONITORING = "/bis/monitoring";
export const ROUTE_MAPPINGS_VIEW = "/self-promotion/mappings-view";
export const ROUTE_ALL_MAPPINGS_MEDIA = "/all-mappings";
export const ROUTE_PROVIDER_WORKFLOW_MONITORING =
  "/provider-workflow-monitoring";
export const ROUTE_DATA_INGESTION = "/audience/data-ingestion";
export const ROUTE_MEDIA_CLASSIFICATION = "/audience/media-classification";
export const ROUTE_E_RETAIL_LEVEL1 = "/e-retail/level1";
export const ROUTE_E_RETAIL_LEVEL2 = "/e-retail/level2";
export const ROUTE_E_RETAIL_LEVEL3 = "/e-retail/level3";
export const ROUTE_E_RETAIL_LEVEL3_DT = "/e-retail/creative-analysis";
export const ROUTE_E_RETAIL_SPENDS = "/e-retail/spends";
export const ROUTE_CTV_LEVEL2 = "/ctv/creative-classification";
export const ROUTE_CTV_LEVEL3 = "/ctv/creative-review";

// API routes. Template: API_ROUTE_<name>
export const API_ROUTE_SIGN_IN = "/api/v1/diane-user/signin";
export const API_ROUTE_LOG_OUT = "/api/v1/diane-user/logout";
export const API_ROUTE_REFRESH_TOKEN = "/api/v1/diane-user/token/refresh";
export const API_ROUTE_USER = "/api/v1/diane-user/user";
export const API_ROUTE_ROLES = "/api/v1/diane-user/roles";
export const API_ROUTE_USER_ROLES = "/api/v1/diane-user/user-roles";
export const API_ROUTE_UPDATE_USER_ROLE = "/api/v1/diane-user/user/:id/role";
export const API_ROUTE_UPDATE_THRESHOLD =
  "/api/v1/diane.mapping.service/settings";
export const API_ROUTE_UPDATE_THRESHOLD_CHANNELS =
  "/api/v1/diane.mapping.service/media-channels-details";
export const API_ROUTE_MAPPING_UNLOCK_ALL_LINES =
  "/api/v1/diane.mapping.service/locked-lines/unlock";
export const API_ROUTE_MAPPING_STATUSES =
  "/api/v1/diane.mapping.service/mapping-statuses";
export const API_ROUTE_UPDATE_MAPPING_STATUSES =
  "/api/v1/diane.mapping.service/mapping";
export const API_ROUTE_PRODUCT_LISTING =
  "/api/v1/diane.taxonomy.service/products/summary";
export const API_ROUTE_NOTIFICATION_HUB = "/notification-hub";

// Pathmatics
export const API_ROUTE_MAPPING_LOCKED_LINES =
  "/api/v1/diane.mapping.service/social-accounts/locked-lines";
export const API_ROUTE_MAPPING_KEYS =
  "/api/v1/diane.mapping.service/social-accounts/summary";
export const API_ROUTE_MAPPING_KEYS_EXPORT =
  "/api/v1/diane.mapping.service/social-accounts/summary/excel-report";
export const API_ROUTE_MAPPING_DETAILS =
  "/api/v1/diane.mapping.service/social-accounts/details";
export const API_ROUTE_MEDIA_CHANNELS =
  "/api/v1/diane.mapping.service/media-channels";
export const API_ROUTE_PATHMATICS_POOL_SIZE =
  "/api/v1/diane.mapping.service/creatives/user-pool";
export const API_ROUTE_PATHMATICS_VALID_VISUAL =
  "/api/v1/diane.mapping.service/creative/valid-visual";
export const API_ROUTE_PATHMATICS_MARK_AS_INVALID =
  "/api/v1/diane.mapping.service/creative/flag-invalid-hash";
export const API_ROUTE_PATHMATICS_REVIEW_CREATIVE =
  "/api/v1/diane.mapping.service/creatives/review-summary";
export const API_ROUTE_PATHMATICS_REVIEW_CREATIVE_EXPORT =
  "/api/v1/diane.mapping.service/creatives/review-summary/excel-report";
export const API_ROUTE_PATHMATICS_REVIEW_DETAILS =
  "/api/v1/diane.mapping.service/creatives/review-details";

// BIS
export const API_ROUTE_BIS_MAPPING_KEYS_LOCKED_LINES =
  "/api/v1/diane.mapping.service/bis-campaigns/locked-lines";
export const API_ROUTE_BIS_MAPPING_KEYS =
  "/api/v1/diane.mapping.service/bis-campaigns/summary";
export const API_ROUTE_BIS_MAPPING_KEYS_EXPORT =
  "/api/v1/diane.mapping.service/bis-campaigns/summary/excel-report";
export const API_ROUTE_BIS_MAPPING_DETAILS =
  "/api/v1/diane.mapping.service/bis-campaigns/details";
export const API_ROUTE_BIS_POOL_SIZE =
  "/api/v1/diane.mapping.service/bis-creative";
export const API_ROUTE_BIS_VALID_VISUAL =
  "/api/v1/diane.mapping.service/bis-creative/valid-visual";
export const API_ROUTE_BIS_REVIEW_CREATIVE =
  "/api/v1/diane.mapping.service/bis-creatives/review-summary";
export const API_ROUTE_BIS_REVIEW_CREATIVE_EXPORT =
  "/api/v1/diane.mapping.service/bis-creatives/review-summary/excel-report";
export const API_ROUTE_BIS_REVIEW_DETAILS =
  "/api/v1/diane.mapping.service/bis-creatives/review-details";
export const API_ROUTE_BIS_MONITORING_MEDIA =
  "/api/v1/diane.reporting.service/bis-creatives/media";
export const API_ROUTE_BIS_MONITORING_MEDIA_EXPORT =
  "/api/v1/diane.reporting.service/bis-creatives/media/excel-export";
export const API_ROUTE_BIS_MONITORING_ADVERTISER =
  "/api/v1/diane.reporting.service/bis-creatives/advertiser";
export const API_ROUTE_BIS_MONITORING_ADVERTISER_EXPORT =
  "/api/v1/diane.reporting.service/bis-creatives/advertiser/excel-export";

// Self Promotion
export const API_ROUTE_SELF_PROMOTION_MAPPING_KEYS =
  "/api/v1/diane.mapping.service/relation-mapping/self-promotion/summary";
export const API_ROUTE_SELF_PROMOTION_REJECT_MAPPING_KEYS =
  "/api/v1/diane.mapping.service/relation-mapping/self-promotion/reject";
export const API_ROUTE_SELF_PROMOTION_ADD_MAPPINGS =
  "/api/v1/diane.mapping.service/relation-mapping/self-promotion";
export const API_ROUTE_MEDIA_LISTING =
  "/api/v1/diane.taxonomy.service/media/summary";
export const API_ROUTE_ADVERTISER_LISTING =
  "/api/v1/diane.taxonomy.service/advertisers/summary";

// All Media Mappings
export const API_ROUTE_DATA_PROVIDERS =
  "/api/v1/diane.mapping.service/data-providers";
export const API_ROUTE_DISPLAY_MEDIA_TYPES =
  "/api/v1/diane.mapping.service/display-types";
export const API_ROUTE_ALL_MEDIA =
  "/api/v1/diane.mapping.service/media/summary";
export const API_ROUTE_LIST_MEDIA_MAPPED =
  "/api/v1/diane.mapping.service/media-mappings/summary";
export const API_ROUTE_REMOVE_MAPPING =
  "/api/v1/diane.mapping.service/media-mappings/remove-mapping";
export const API_ROUTE_ADD_MAPPING =
  "/api/v1/diane.mapping.service/media-mappings/add-mapping";

// workflow monitoring
export const API_ROUTE_PROVIDER_WORKFLOW_MONITORING =
  "/api/v1/diane.reporting.service/media-download-history";

// audience
export const API_ROUTE_AUDIENCE_DATA_INGESTION =
  "/api/v1/diane.audience.service/ingestion/files";
export const API_ROUTE_AUDIENCE_DATA_INGESTION_SUMMARY =
  "/api/v1/diane.audience.service/ingestion/files/summary";
export const API_ROUTE_AUDIENCE_CLASSIFICATION_DOMAINS =
  "/api/v1/diane.audience.service/classification/domains";
export const API_ROUTE_AUDIENCE_CLASSIFICATION_MEDIA_SEARCH =
  "/api/v1/diane.audience.service/classification/media/search";
export const API_ROUTE_AUDIENCE_CLASSIFICATION_MAP =
  "/api/v1/diane.audience.service/classification/domains/{id}/map";
export const API_ROUTE_AUDIENCE_CLASSIFICATION_REJECT =
  "/api/v1/diane.audience.service/classification/domains/{id}/reject";

// eRetail
export const API_ROUTE_E_RETAIL_BUYERS_DATA =
  "/api/v1/diane.eretailmapping.service/buyers/summary";
export const API_ROUTE_E_RETAIL_BUYERS_DATA_EXPORT =
  "/api/v1/diane.eretailmapping.service/buyers/summary/excel-report";
export const API_ROUTE_E_RETAIL_BUYERS_DETAILS =
  "/api/v1/diane.eretailmapping.service/buyers/details";
export const API_ROUTE_E_RETAIL_BUYERS_LOCKED_LINES =
  "/api/v1/diane.eretailmapping.service/buyers/locked-lines";
export const API_ROUTE_E_RETAIL_BUYER_STATUSES =
  "/api/v1/diane.eretailmapping.service/buyer-statuses";
export const API_ROUTE_E_RETAIL_BUYER_STATUS_ASSIGNMENT =
  "/api/v1/diane.eretailmapping.service/buyers/status-assignment";
export const API_ROUTE_E_RETAIL_ADVERTISER_EXCLUSIONS =
  "/api/v1/diane.eretailmapping.service/buyers/advertiser-exclusions";
export const API_ROUTE_E_RETAIL_POOL_SIZE =
  "/api/v1/diane.eretailmapping.service/creatives";
export const API_ROUTE_E_RETAIL_VALID_VISUAL =
  "/api/v1/diane.eretailmapping.service/creative/valid-visual";
export const API_ROUTE_E_RETAIL_UPDATE_MAPPING_STATUSES =
  "/api/v1/diane.eretailmapping.service/mapping";
export const API_ROUTE_E_RETAIL_REVIEW_CREATIVE =
  "/api/v1/diane.eretailmapping.service/creatives/review-summary";
export const API_ROUTE_E_RETAIL_REVIEW_CREATIVE_EXPORT =
  "/api/v1/diane.eretailmapping.service/creatives/review-summary/excel-report";
export const API_ROUTE_E_RETAIL_REVIEW_DETAILS =
  "/api/v1/diane.eretailmapping.service/creatives/review-details";
export const API_ROUTE_E_RETAIL_CREATIVE_ANALYSIS =
  "/api/v1/diane.eretailmapping.service/creatives/digital-team-review-summary";
export const API_ROUTE_E_RETAIL_CREATIVE_ANALYSIS_EXPORT =
  "/api/v1/diane.eretailmapping.service/creatives/digital-team-review-summary/excel-report";
export const API_ROUTE_E_RETAIL_CREATIVE_ANALYSIS_DETAILS =
  "/api/v1/diane.eretailmapping.service/creatives/digital-team-review-details";
export const API_ROUTE_E_RETAIL_SPENDS =
  "/api/v1/diane.eretailmapping.service/spend/summary";
export const API_ROUTE_E_RETAIL_SPENDS_COMPUTE =
  "/api/v1/diane.eretailmapping.service/spend/trigger-computation";
export const API_ROUTE_E_RETAIL_SPENDS_TRANSFER =
  "/api/v1/diane.eretailmapping.service/spend/trigger-transfer";
export const API_ROUTE_E_RETAIL_SPENDS_DOWNLOAD =
  "/api/v1/diane.eretailmapping.service/spend/download-report";

// CTV
export const API_ROUTE_CTV_POOL_SIZE =
  "/api/v1/diane.ctvmapping.service/creatives";
export const API_ROUTE_CTV_VALID_VISUAL =
  "/api/v1/diane.ctvmapping.service/creative/valid-visual";
export const API_ROUTE_CTV_UPDATE_MAPPING_STATUSES =
  "/api/v1/diane.ctvmapping.service/mapping";
export const API_ROUTE_CTV_REVIEW_CREATIVE =
  "/api/v1/diane.ctvmapping.service/creatives/review-summary";
export const API_ROUTE_CTV_REVIEW_CREATIVE_EXPORT =
  "/api/v1/diane.ctvmapping.service/creatives/review-summary/excel-report";
export const API_ROUTE_CTV_REVIEW_DETAILS =
  "/api/v1/diane.ctvmapping.service/creatives/review-details";
